/* eslint-disable sort-keys */
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Utility hook which returns information about the browser window viewport's current breakpoint.
 */
export var useBreakpoint = function useBreakpoint() {
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  var isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  var isDesktopSmall = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  var isDesktop = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  var isDesktopLarge = useMediaQuery(theme.breakpoints.up('xl'));

  /**
   * Returns the current breakpoint, like 'xs'
   */
  var getBreakpoint = function getBreakpoint() {
    if (isMobile) return 'xs';
    if (isTablet) return 'sm';
    if (isDesktopSmall) return 'md';
    if (isDesktop) return 'lg';
    if (isDesktopLarge) return 'xl';
    return 'lg';
  };
  return {
    getBreakpoint: getBreakpoint,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktopSmall: isDesktopSmall,
    isDesktop: isDesktop,
    isDesktopLarge: isDesktopLarge
  };
};